import React, { memo } from 'react';
import { useFragment, graphql } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { IssueTypeCell$key } from '@atlassian/jira-relay/src/__generated__/IssueTypeCell.graphql';
import { IconCell } from '../../icon-cell/IconCell.tsx';

type Props = {
	fieldRef: IssueTypeCell$key;
};

export const IssueTypeCell = memo(({ fieldRef }: Props) => {
	const data = useFragment<IssueTypeCell$key>(
		graphql`
			fragment IssueTypeCell on JiraIssueTypeField
			@argumentDefinitions(
				isSingleLineEventDelegatorEnabled: {
					type: "Boolean!"
					provider: "@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider"
				}
			) {
				...IconCell @include(if: $isSingleLineEventDelegatorEnabled)
				issueType @skip(if: $isSingleLineEventDelegatorEnabled) {
					avatar {
						small
					}
					name
				}
			}
		`,
		fieldRef,
	);

	const { issueType } = data;

	return (
		<IconCell
			iconUrlOld={issueType?.avatar?.small}
			nameOld={issueType?.name}
			fragmentRef={data && fg('issue_table_single_line_row_height_event_delegator') ? data : null}
			showErrorIconWhenEmpty
		/>
	);
});
